module.exports = __webpack_public_path__ + "static/media/home2.4196cc66.jpg";